import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HpOidcClientModule, provideOidcClient } from '@upmc-healthplan-npm/oidc-client';
import { RouterModule } from '@angular/router';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { LayoutModule } from './layout/layout.module';
import { AttachHeaderInterceptor } from './interceptors/api-key.interceptor';
import { AuthorizationInterceptor } from './interceptors/auth-token.interceptor';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { ApplicationInsightsService } from './services/application-insights.service';
import { POLDocumentService } from './services/document.service';
import { POLCoreEffects } from './state/core.effects';
import { ErrorComponent } from './pages/error/error.component';
import { NavigationEffects } from './layout/navigation/state/navigation.effects';
import { coreReducers } from './state/core.state';
import { FEATURE_NAME } from './models/state.model';
import { FEATURE_NAME as MEMBER_FEATURE_NAME } from '../features/member/member.model';
import { memberFeatureReducers } from '../features/member/member.state';
import { HeliosSsoComponent } from './pages/helios-sso/helios-sso.component';
import { SharedModule } from '../shared/shared.module';
import { playgroundComponent } from './pages/playground/playground.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LegacySsoComponent } from './pages/legacy-sso/legacy-sso.component';
import { resolveOauthConfig } from '../environment-resolver';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    RouterModule,
    LayoutModule,
    SharedModule,
    /* eslint-disable */
    // HpOidcClientModule.forRoot(() => {
    //   return window['OAUTH_CONFIG'];
    // }),
    /* eslint-enable */
    StoreModule.forFeature(FEATURE_NAME, coreReducers),
    StoreModule.forFeature(MEMBER_FEATURE_NAME, memberFeatureReducers),
    EffectsModule.forFeature([POLCoreEffects, NavigationEffects]),
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    ErrorComponent,
    HeliosSsoComponent,
    LegacySsoComponent,
    playgroundComponent
  ],
  providers: [
    provideOidcClient(resolveOauthConfig as any),
  ],
  exports: [
    ErrorComponent,
    LayoutModule,
    playgroundComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class POLCoreModule {
  constructor(@Optional() @SkipSelf() coreModule?: POLCoreModule) {
    if (coreModule) {
      throw new Error(
        'The Core Module is already loaded. Do not import it into any module except the root App.');
    }
  }

  static forRoot(): ModuleWithProviders<POLCoreModule> {
    return {
      ngModule: POLCoreModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AttachHeaderInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthorizationInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiInterceptor,
          multi: true
        },
        ApplicationInsightsService,
        POLDocumentService
      ]
    };
  }
}
